<template>
 <div class="vertical-center">
        <!-- <img v-if="showloading == true" src="../assets/245.gif" style="z-index: 999;position: fixed; top: 15px;left: 40%;" />
        -->
        <div class="inner-block">
    
    <div class="vue-tempalte">
        <form>
            <h3>Admin - Sign In</h3>
            <div class="form-group">
                <label>Email address</label>
                <input type="email" class="form-control form-control-lg" id="email" value="" required />
            </div>
            <div class="form-group">
                <label>Password</label>
                <input type="password" class="form-control form-control-lg" id="password" value="" required />
            </div>
            <button type="submit" @click.prevent="sLogin" class="btn btn-dark btn-lg btn-block">Sign In</button>
            <!-- <p class="forgot-password text-right mt-2 mb-4">
                <router-link to="/forgot-password">Forgot password ?</router-link>
            </p> -->
            <p class="forgot-password text-left">
                Don't have an account? 
                <router-link :to="{name: 'signup'}">sign up</router-link>
            </p>
        </form>
    </div>
     </div>
      </div>
      
</template>

<script>
import firebase from 'firebase';

export default {

  data(){
    return{
      showloading: false
    }
  },
   computed:{
     user: function(){
       return this.$store.state.user.username;
     },
    // email: function(){
    //   return this.$store.state.user.email;
    // }
    },
   methods:{
        sLogin: function(){
            this.showloading = true;
            var email = document.getElementById("email").value;
            var password = document.getElementById("password").value;
               console.log(email+" "+password);
            

            firebase
                .auth()
                .signInWithEmailAndPassword(email, password)
                .then((data)=>{
                    
                    
                    //console.log(data);
                    //var email2 = data.user.email;
                    //var username2 = data.user.displayName;
                    if(data.user.displayName == "admin"){
                    if(this.$store.dispatch('setUser',data.user.displayName)){
                     // console.log("user: "+this.user);
                     //this.showloading = false;
                    this.$router.push({ path: '/AdminDashboard' });
                    // window.location.href=('/');
                      
                    }
                    }else{
                        alert("Invalid Login");
                    }
                
                    }).catch(err=>{
                    console.log(err.message)
                });

                    
                 

        }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
body {
  background: white !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
}
body,
html,
.App,
.vue-tempalte,
.vertical-center {
  width: 100%;
  height: 100%;
}
.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}
.vertical-center {
  display: flex;
  text-align: left;
  justify-content: center;
  flex-direction: column;    
}
.inner-block {
  width: 450px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all .3s;
}
.vertical-center .form-control:focus {
  border-color: #2554FF;
  box-shadow: none;
}
.vertical-center h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}
label {
  font-weight: 500;
}
.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7a7a7a;
  margin: 0;
}
.forgot-password a {
  color: #2554FF;
}
.social-icons {
  text-align: center;
  font-family: "Open Sans";
  font-weight: 300;
  font-size: 1.5em;
  color: #222222;
}
.social-icons ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-icons ul li {
  display: inline-block;
  zoom: 1;
  width: 65px;
  vertical-align: middle;
  border: 1px solid #e3e8f9;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  background: #f4f6ff;
}
.social-icons ul li a {
  display: block;
  font-size: 1.4em;
  margin: 0 5px;
  text-decoration: none;
}
.social-icons ul li a i {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
.social-icons ul li a:focus i,
.social-icons ul li a:active i {
  transition: none;
  color: #222222;
}
</style>
